module.exports = __webpack_public_path__ + "static/media/Group 1285.a283b579.svg";